import { render, staticRenderFns } from "./CreateUserForm.vue?vue&type=template&id=767e9fda&scoped=true"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"
import style0 from "./CreateUserForm.vue?vue&type=style&index=0&id=767e9fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e9fda",
  null
  
)

export default component.exports